import { render } from "./VideoCard.vue?vue&type=template&id=94683aac&scoped=true"
import script from "./VideoCard.vue?vue&type=script&lang=js"
export * from "./VideoCard.vue?vue&type=script&lang=js"

import "./VideoCard.vue?vue&type=style&index=0&id=94683aac&lang=scss&scoped=true"
import "./VideoCard.vue?vue&type=style&index=1&id=94683aac&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94683aac"]])

export default __exports__